import { TRIP_DETAILS_PAGE, navigateToPath } from '#src/utils';

export const useShoppingBasketDefaultURLOnFailure = () => {
  const onFailure = () => {
    navigateToPath(TRIP_DETAILS_PAGE);
  };

  return {
    onFailure,
  };
};
